/**
 * AUTO-GENERATED — do not edit by hand.
 * Regenerate with: `node scripts/sync-seo-content.js`
 * Source of truth: scripts/changelog-data.cjs
 */

export const CHANGELOG = [
  {
    "date": "2026-07-01",
    "type": "feature",
    "title": "Public changelog launched",
    "summary": "You are reading it. Every notable AMP Predict release now lands here so users, press, and search engines can track what shipped and when."
  },
  {
    "date": "2026-07-01",
    "type": "improvement",
    "title": "Cleaner article and market headers",
    "summary": "Learn articles, category pages, and market detail pages now open with a single unified header — breadcrumbs, title, meta strip, and AEO paragraph — instead of stacking multiple boxes."
  },
  {
    "date": "2026-07-01",
    "type": "feature",
    "title": "Clean market URLs",
    "summary": "Every live market now has a permanent human-readable URL like /markets/sports/nfl-super-bowl-winner. Old ID-based links 301 to the new slug URLs automatically."
  },
  {
    "date": "2026-07-01",
    "type": "feature",
    "title": "Learn hub with 5 in-depth guides",
    "summary": "A new /learn section explains what prediction markets are, how YES/NO event contracts work, how implied probability works, and how to practice forecasting risk-free with virtual TK¢."
  },
  {
    "date": "2026-07-01",
    "type": "feature",
    "title": "Category landing pages",
    "summary": "Dedicated /markets/politics, /sports, /technology, /economics, and /world-events pages with contextual descriptions and JSON-LD breadcrumbs for better discoverability."
  },
  {
    "date": "2026-07-01",
    "type": "improvement",
    "title": "Search-engine and AI-answer optimization",
    "summary": "Every public page now ships as pre-rendered HTML with route-specific titles, canonical URLs, FAQ schema, and AEO answer blocks so crawlers and AI assistants can index the app without running JavaScript."
  },
  {
    "date": "2026-06-25",
    "type": "feature",
    "title": "Account deletion (Apple 5.1.1(v) compliance)",
    "summary": "Mobile and web users can now hard-delete their AMP Predict account and all associated data directly from Profile Settings. Active subscriptions are cancelled automatically."
  },
  {
    "date": "2026-06-20",
    "type": "improvement",
    "title": "Unified EULA and Terms",
    "summary": "Consolidated the previous split Terms and EULA into a single End User License Agreement covering Delaware governing law, SMS consent, and Apple standard EULA compliance."
  },
  {
    "date": "2026-06-15",
    "type": "improvement",
    "title": "Redesigned Ideas and Orderbook screens",
    "summary": "The community Ideas page and market Orderbook modal were refactored into smaller, cleaner components — faster to load, easier to scan, and more consistent across device sizes."
  },
  {
    "date": "2026-06-10",
    "type": "feature",
    "title": "iOS and Android app parity",
    "summary": "Native mobile apps now share the same account, virtual TK¢ balance, positions, and watchlists as the web app. Push notifications alert you the moment your markets resolve."
  }
];
